import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Identity */}
          <div>
            <img 
              src="https://static.readdy.ai/image/d57f52ecca312558916e136936375c65/3d1ca745aa0674e2a18c39b7e5b64cd1.png" 
              alt="AbrilWeldWorksPro LLC" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Column 2 - Newsletter */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wide">MANTENTE INFORMADO</h3>
            <p className="text-gray-300 text-sm mb-4">
              Suscríbete para recibir noticias y ofertas especiales
            </p>
            <div className="text-gray-400 text-xs mt-4">
              <Link to="/privacy" className="hover:text-orange-400 transition-colors cursor-pointer">
                Política de privacidad
              </Link>
            </div>
          </div>

          {/* Column 3 - Navigation */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wide">{t('footer_quick_links')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="#inicio" className="text-gray-300 hover:text-orange-400 transition-colors text-sm cursor-pointer">
                  {t('nav_home')}
                </a>
              </li>
              <li>
                <a href="#sobre-nosotros" className="text-gray-300 hover:text-orange-400 transition-colors text-sm cursor-pointer">
                  {t('nav_about')}
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-300 hover:text-orange-400 transition-colors text-sm cursor-pointer">
                  {t('nav_services')}
                </a>
              </li>
              <li>
                <a href="#trabajos" className="text-gray-300 hover:text-orange-400 transition-colors text-sm cursor-pointer">
                  {t('nav_gallery')}
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors text-sm cursor-pointer">
                  {t('nav_contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Social */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm uppercase tracking-wide">SÍGUENOS</h3>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-orange-600 rounded-full transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center">
              © 2025 AbrilWeldWorksPro LLC. {t('footer_rights')}
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#sobre-nosotros" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                {t('nav_about')}
              </a>
              <a href="#servicios" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                {t('nav_services')}
              </a>
              <a href="#trabajos" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                {t('nav_gallery')}
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                {t('footer_powered')}
              </a>
            </div>
          </div>
          
          {/* Brand Name */}
          <div className="mt-8 text-center">
            <h2 className="text-3xl font-bold text-white tracking-wider">
              ABRILWELDWORKSPROLLC
            </h2>
          </div>
        </div>
      </div>
    </footer>
  );
}
